import {
  endOfMonth,
  endOfToday,
  endOfTomorrow,
  endOfWeek,
  endOfYesterday,
  startOfToday,
} from "date-fns";
import i18next from "i18next";

export const colors = {
  dark: "#00B75F",
  gold: "#00B75F",
  goldAccent: "#00B75F",
  goldDark: "#00B75F",
  gray: "#eeeeee",
  greyBorder: "#e5e5e5",
  signatureBorder: "#CECECE",
  white: "#fff",
  white20: "rgba(255, 255, 255, 0.2)",
  black: "#000",
  black80: "rgba(44, 44, 45, 0.8)",
  black60: "rgba(44, 44, 45, 0.6)",
  black40: "rgba(44, 44, 45, 0.4)",
  black20: "rgba(44, 44, 45, 0.2)",
  black5: " rgba(44, 44, 45, 0.05)",
  black3: "rgba(44, 44, 45, 0.03)",
  green: "#66765b",
  greenLight: "#cce7bb",
  red: "#7a4a4a",
  redLight: "#e2abab",
  textPrimary: "#2c2c2d",
  textSecondary: "gray",
  textGold: "rgba(182, 139, 55, 0.8)",
  outline: "rgba(44, 44, 45, 0.05)",
  text_gold: "#b68b37",
  goldNoRgba: "#b68b37cc",
  votingSummaryBg: "rgba(182, 139, 55, 0.1)",
};

export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints["video"] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

export const SELECTED_AUDIO_INPUT_KEY = "TwilioVideoApp-selectedAudioInput";
export const SELECTED_AUDIO_OUTPUT_KEY = "TwilioVideoApp-selectedAudioOutput";
export const SELECTED_VIDEO_INPUT_KEY = "TwilioVideoApp-selectedVideoInput";

export const GALLERY_VIEW_ASPECT_RATIO = 9 / 16; // 16:9
export const GALLERY_VIEW_MARGIN = 3;

export const today = new Date();
export const startToday = startOfToday().toISOString();
export const endToday = endOfToday().toISOString();
export const endTomorrow = endOfTomorrow().toISOString();
export const endWeek = endOfWeek(today, { weekStartsOn: 1 }).toISOString();
export const endMonth = endOfMonth(today).toISOString();
export const overdue = endOfYesterday().toISOString();

export const phoneRegExp =
  /^(\+48|0048|48)? ?[0-9]{3} ?[0-9]{3} ?[0-9]{3}$|^\+1 ?[0-9]{3} ?[0-9]{3} ?[0-9]{4}$|^\+966 ?[0-9]{9}$/;

export const currentLanguage =
  JSON.parse(String(localStorage.getItem("lang"))) || i18next.language || "en";

export const descriptionCharactersMax = 1000000;

export const dateFormats = {
  main: "dd.MM.yyyy",
};

export enum Language {
  ar = "ar",
  en = "en",
}
